import { render, staticRenderFns } from "./ActivityPanel.vue?vue&type=template&id=3506c907"
import script from "./ActivityPanel.vue?vue&type=script&lang=js"
export * from "./ActivityPanel.vue?vue&type=script&lang=js"
import style0 from "./ActivityPanel.vue?vue&type=style&index=0&id=3506c907&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports